import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useMyEvents } from "@/hooks/useMyEvents";
import { MyEventCardHorizontal } from "@/components/profile/MyEventCardHorizontal";
import { useAuth } from "@/contexts/AuthContext";

const AllMyEventsPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { myEvents, loading } = useMyEvents(user?.id);

  // Combine all events sorted by startDate descending
  const allEvents = [
    ...myEvents.active,
    ...myEvents.upcoming,
    ...myEvents.finished,
  ].sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-background border-b px-4 py-3 flex items-center gap-3">
        <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <h1 className="text-lg font-semibold">Mis Eventos</h1>
        <span className="text-sm text-muted-foreground">({allEvents.length})</span>
      </div>

      {/* Content */}
      <div className="p-4 space-y-3 max-w-2xl mx-auto">
        {loading ? (
          <div className="space-y-3">
            {[1, 2, 3].map(i => (
              <div key={i} className="h-36 bg-muted rounded-lg animate-pulse" />
            ))}
          </div>
        ) : allEvents.length === 0 ? (
          <div className="text-center py-16">
            <p className="text-muted-foreground">No tienes eventos registrados</p>
            <Button className="mt-4" onClick={() => navigate('/')}>
              Explorar Eventos
            </Button>
          </div>
        ) : (
          allEvents.map(event => (
            <MyEventCardHorizontal key={event.registrationId || event.id} event={event} />
          ))
        )}
      </div>
    </div>
  );
};

export default AllMyEventsPage;
